import React, { useMemo } from 'react';
import {DateHelpers} from '../../../../../../helpers/date-helpers';
import FeedPostContentFirmLink from '../FeedPostContentFirmLink';

const TypeCandidatePurchasesInbounds = props => {
  const {
    post: {
      currentSchoolName,
      FirmName,
      FirmUrlAlias,
      FirmActive,
      NewsFeedDateAdd,
      Date,
    },
  } = props;

  const date = useMemo(() => {
    const [year] = DateHelpers.getDateArray(Date);
    const currentYear = DateHelpers.getCurrentYear();

    return currentYear > Number(year)
      ? DateHelpers.getMonthNameDayYearFormat(Date)
      : NewsFeedDateAdd;
  }, [Date, NewsFeedDateAdd]);

  return (
    <div className="feed-post-content__inner feed-post-content__inner--typed">
      <div className="feed-post-content__top">
        <strong className="feed-post-content__text">GoBuyside Member</strong>
        <div className="feed-post-content__text">from</div>
        <FeedPostContentFirmLink
          isActive={FirmActive === 'Yes'}
          alias={FirmUrlAlias}
          firm={FirmName}
          school={currentSchoolName}
        />
        <div className="feed-post-content__text">purchased 5 inbounds</div>
      </div>
      <div className="feed-post-content__date">{date}</div>
    </div>
  );
};

export default TypeCandidatePurchasesInbounds;
